module.exports = __webpack_public_path__ + "b0937351b33620a3bc5279fb7724cc7f.MP3";